// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-container {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #E57A00 0%, #FF8C00 20%, #ffaa008e  80%, #ff8c0073 100%);
  padding: 20px;
  font-family: 'Montserrat', sans-serif;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto;
}

.maintenance-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 50% 20%, rgba(229, 122, 0, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 50% 80%, rgba(24, 27, 37, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 30% 50%, rgba(255, 140, 0, 0.05) 0%, transparent 50%);
  pointer-events: none;
  animation: backgroundShift 20s ease-in-out infinite;
}

@keyframes backgroundShift {
  0%, 100% {
    background: 
      radial-gradient(circle at 50% 20%, rgba(229, 122, 0, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 50% 80%, rgba(24, 27, 37, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 30% 50%, rgba(255, 140, 0, 0.05) 0%, transparent 50%);
  }
  50% {
    background: 
      radial-gradient(circle at 30% 30%, rgba(229, 122, 0, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 70% 70%, rgba(24, 27, 37, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 70% 30%, rgba(255, 140, 0, 0.03) 0%, transparent 50%);
  }
}

.maintenance-content {
  background: white;
  border-radius: 20px;
  padding: 50px 40px;
  text-align: center;
  max-width: 1200px;
  width: 100%;
  max-height: calc(100vh - 40px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(229, 122, 0, 0.1);
  position: relative;
  margin: 0;
  box-sizing: border-box;
  z-index: 1;
  overflow-y: auto;
}

.maintenance-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #E57A00, #FF8C00);
}

.maintenance-icon {
  margin-bottom: 30px;
  animation: pulse 2s infinite;
}

.logo-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  filter: drop-shadow(0 2px 4px rgba(229, 122, 0, 0.2));
  transition: transform 0.3s ease;
  border-radius: 12px;
}

.logo-image:hover {
  transform: scale(1.05);
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.maintenance-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 20px;
  line-height: 1.2;
}

.maintenance-message {
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.6;
  margin-bottom: 35px;
}

.maintenance-details {
  display: flex;
  justify-content: space-around;
  margin-bottom: 35px;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 120px;
  transition: transform 0.2s ease;
}

.detail-item:hover {
  transform: translateY(-2px);
}

.detail-icon {
  font-size: 2rem;
  margin-bottom: 5px;
  filter: drop-shadow(0 1px 2px rgba(229, 122, 0, 0.3));
}

.detail-item span:last-child {
  font-size: 0.9rem;
  color: #4a5568;
  font-weight: 500;
}

.maintenance-timeline {
  background: #fef7f0;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  border-left: 4px solid #E57A00;
}

.timeline-text {
  font-size: 1.1rem;
  color: #2d3748;
  margin-bottom: 8px;
}

.timeline-subtext {
  font-size: 0.9rem;
  color: #718096;
  margin: 0;
}

.maintenance-contact {
  margin-bottom: 30px;
}

.maintenance-contact p {
  color: #4a5568;
  margin-bottom: 15px;
  font-size: 1rem;
}

.contact-link {
  display: inline-block;
  background: linear-gradient(135deg, #E57A00, #FF8C00);
  color: white;
  padding: 12px 30px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(229, 122, 0, 0.3);
}

.contact-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(229, 122, 0, 0.4);
  text-decoration: none;
  color: white;
}

.maintenance-footer {
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}

.maintenance-footer p {
  color: #a0aec0;
  font-size: 0.9rem;
  margin: 0;
}

/* Desktop - Pantallas grandes */
@media (min-width: 1200px) {
  .maintenance-content {
    max-width: 1400px;
    padding: 80px 60px;
  }
  
  .logo-image {
    width: 100px;
    height: 100px;
  }
  
  .maintenance-title {
    font-size: 3rem;
    margin-bottom: 30px;
  }
  
  .maintenance-message {
    font-size: 1.3rem;
    margin-bottom: 50px;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .maintenance-details {
    margin-bottom: 50px;
    gap: 40px;
    max-width: 1000px;
  }
  
  .detail-item span:last-child {
    font-size: 1rem;
  }
  
  .maintenance-timeline {
    padding: 35px;
    margin-bottom: 40px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    background: #fef7f0;
    border-left: 4px solid #E57A00;
  }
  
  .timeline-text {
    font-size: 1.2rem;
  }
  
  .timeline-subtext {
    font-size: 1rem;
  }
  
  .maintenance-contact {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
}

/* Pantallas extra grandes (4K, ultrawide) */
@media (min-width: 1600px) {
  .maintenance-container {
    padding: 30px;
    height: 100vh;
    min-height: 100vh;
  }
  
  .maintenance-content {
    max-width: 1400px;
    max-height: calc(100vh - 60px);
    padding: 80px 60px;
    margin: 0;
  }
  
  .maintenance-title {
    font-size: 3.2rem;
    margin-bottom: 35px;
  }
  
  .maintenance-message {
    font-size: 1.3rem;
    margin-bottom: 50px;
    max-width: 900px;
  }
  
  .maintenance-details {
    margin-bottom: 50px;
    gap: 45px;
    max-width: 1100px;
  }
  
  .detail-item span:last-child {
    font-size: 1rem;
  }
  
  .maintenance-timeline {
    padding: 35px;
    margin-bottom: 45px;
    max-width: 650px;
    background: #fef7f0;
    border-left: 4px solid #E57A00;
  }
  
  .timeline-text {
    font-size: 1.2rem;
  }
  
  .timeline-subtext {
    font-size: 1rem;
  }
  
  .maintenance-contact {
    max-width: 550px;
  }
  
  .contact-link {
    padding: 14px 35px;
    font-size: 1rem;
  }
}

/* Pantallas ultra anchas (más de 1920px) */
@media (min-width: 1920px) {
  .maintenance-container {
    padding: 40px;
    height: 100vh;
    min-height: 100vh;
    align-items: center;
  }
  
  .maintenance-content {
    max-width: 1400px;
    max-height: calc(100vh - 80px);
    padding: 80px 60px;
    margin: 0;
  }
  
  .logo-image {
    width: 120px;
    height: 120px;
  }
  
  .maintenance-title {
    font-size: 3.5rem;
    margin-bottom: 40px;
  }
  
  .maintenance-message {
    font-size: 1.4rem;
    margin-bottom: 60px;
    max-width: 1000px;
  }
  
  .maintenance-details {
    margin-bottom: 60px;
    gap: 50px;
    max-width: 1200px;
  }
  
  .detail-item span:last-child {
    font-size: 1.1rem;
  }
  
  .maintenance-timeline {
    padding: 40px;
    margin-bottom: 50px;
    max-width: 700px;
  }
  
  .timeline-text {
    font-size: 1.3rem;
  }
  
  .timeline-subtext {
    font-size: 1.1rem;
  }
  
  .maintenance-contact {
    max-width: 600px;
  }
  
  .contact-link {
    padding: 15px 40px;
    font-size: 1.1rem;
  }
}

/* Pantallas ultrawide muy grandes (más de 2560px) */
@media (min-width: 2560px) {
  .maintenance-container {
    padding: 50px;
    height: 100vh;
    min-height: 100vh;
  }
  
  .maintenance-content {
    max-width: 1600px;
    max-height: calc(100vh - 100px);
    padding: 90px 70px;
    margin: 0;
  }
  
  .logo-image {
    width: 140px;
    height: 140px;
  }
  
  .maintenance-title {
    font-size: 4rem;
    margin-bottom: 50px;
  }
  
  .maintenance-message {
    font-size: 1.6rem;
    margin-bottom: 70px;
    max-width: 1200px;
  }
  
  .maintenance-details {
    margin-bottom: 70px;
    gap: 60px;
    max-width: 1400px;
  }
  
  .detail-item span:last-child {
    font-size: 1.2rem;
  }
  
  .maintenance-timeline {
    padding: 50px;
    margin-bottom: 60px;
    max-width: 800px;
  }
  
  .timeline-text {
    font-size: 1.5rem;
  }
  
  .timeline-subtext {
    font-size: 1.2rem;
  }
  
  .maintenance-contact {
    max-width: 700px;
  }
  
  .contact-link {
    padding: 18px 45px;
    font-size: 1.2rem;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .maintenance-content {
    max-width: 1000px;
    padding: 70px 50px;
  }
  
  .maintenance-title {
    font-size: 2.8rem;
  }
  
  .maintenance-message {
    font-size: 1.2rem;
  }
}

/* Tablet */
@media (min-width: 769px) and (max-width: 991px) {
  .maintenance-content {
    max-width: 800px;
    padding: 50px 30px;
  }
  
  .maintenance-title {
    font-size: 2.2rem;
  }
}

/* Responsive Design - Móvil */
@media (max-width: 768px) {
  .maintenance-container {
    padding: 20px 10px;
    height: 100vh;
    min-height: 100vh;
    align-items: flex-start;
    padding-top: 30px;
  }
  
  .maintenance-content {
    padding: 30px 20px;
    margin: 0;
    width: 100%;
    max-height: calc(100vh - 60px);
  }
  
  .logo-image {
    width: 60px;
    height: 60px;
  }
  
  .maintenance-title {
    font-size: 2rem;
    margin-bottom: 15px;
  }
  
  .maintenance-message {
    font-size: 1rem;
    margin-bottom: 25px;
  }
  
  .maintenance-details {
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
    gap: 15px;
  }
  
  .detail-item {
    min-width: auto;
  }
  
  .maintenance-timeline {
    padding: 20px;
    margin-bottom: 25px;
  }
  
  .maintenance-contact {
    margin-bottom: 20px;
  }
  
  .maintenance-footer {
    padding-top: 15px;
  }
}

@media (max-width: 480px) {
  .maintenance-container {
    padding: 15px 5px;
    height: 100vh;
    min-height: 100vh;
    padding-top: 20px;
  }
  
  .maintenance-content {
    padding: 20px 15px;
    border-radius: 15px;
    max-height: calc(100vh - 40px);
  }
  
  .logo-image {
    width: 50px;
    height: 50px;
  }
  
  .maintenance-title {
    font-size: 1.8rem;
    margin-bottom: 12px;
  }
  
  .maintenance-message {
    font-size: 0.95rem;
    margin-bottom: 20px;
    line-height: 1.5;
  }
  
  .maintenance-details {
    margin-bottom: 20px;
    gap: 12px;
  }
  
  .detail-icon {
    font-size: 1.5rem;
  }
  
  .detail-item span:last-child {
    font-size: 0.85rem;
  }
  
  .maintenance-timeline {
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .timeline-text {
    font-size: 1rem;
  }
  
  .timeline-subtext {
    font-size: 0.85rem;
  }
  
  .maintenance-contact {
    margin-bottom: 15px;
  }
  
  .maintenance-contact p {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }
  
  .contact-link {
    padding: 10px 25px;
    font-size: 0.9rem;
  }
  
  .maintenance-footer {
    padding-top: 12px;
  }
  
  .maintenance-footer p {
    font-size: 0.8rem;
  }
}

/* Pantallas muy pequeñas (menos de 360px) */
@media (max-width: 360px) {
  .maintenance-container {
    padding: 10px 2px;
    height: 100vh;
    min-height: 100vh;
    padding-top: 15px;
  }
  
  .maintenance-content {
    padding: 15px 10px;
    border-radius: 12px;
    max-height: calc(100vh - 30px);
  }
  
  .logo-image {
    width: 45px;
    height: 45px;
  }
  
  .maintenance-title {
    font-size: 1.6rem;
    margin-bottom: 10px;
  }
  
  .maintenance-message {
    font-size: 0.9rem;
    margin-bottom: 18px;
    line-height: 1.4;
  }
  
  .maintenance-details {
    margin-bottom: 18px;
    gap: 10px;
  }
  
  .detail-icon {
    font-size: 1.3rem;
  }
  
  .detail-item span:last-child {
    font-size: 0.8rem;
  }
  
  .maintenance-timeline {
    padding: 12px;
    margin-bottom: 18px;
  }
  
  .timeline-text {
    font-size: 0.95rem;
  }
  
  .timeline-subtext {
    font-size: 0.8rem;
  }
  
  .maintenance-contact {
    margin-bottom: 12px;
  }
  
  .maintenance-contact p {
    font-size: 0.85rem;
    margin-bottom: 8px;
  }
  
  .contact-link {
    padding: 8px 20px;
    font-size: 0.85rem;
  }
  
  .maintenance-footer {
    padding-top: 10px;
  }
  
  .maintenance-footer p {
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/maintenance/maintenance.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4FAA4F;EAC5F,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;mFAGiF;EACjF,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE;IACE;;;qFAGiF;EACnF;EACA;IACE;;;qFAGiF;EACnF;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,6EAA6E;EAC7E,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,qDAAqD;EACrD,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;IACb,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,aAAa;IACb,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".maintenance-container {\n  min-height: 100vh;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(180deg, #E57A00 0%, #FF8C00 20%, #ffaa008e  80%, #ff8c0073 100%);\n  padding: 20px;\n  font-family: 'Montserrat', sans-serif;\n  box-sizing: border-box;\n  position: relative;\n  overflow-y: auto;\n}\n\n.maintenance-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 50% 20%, rgba(229, 122, 0, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 50% 80%, rgba(24, 27, 37, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 30% 50%, rgba(255, 140, 0, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n  animation: backgroundShift 20s ease-in-out infinite;\n}\n\n@keyframes backgroundShift {\n  0%, 100% {\n    background: \n      radial-gradient(circle at 50% 20%, rgba(229, 122, 0, 0.1) 0%, transparent 50%),\n      radial-gradient(circle at 50% 80%, rgba(24, 27, 37, 0.1) 0%, transparent 50%),\n      radial-gradient(circle at 30% 50%, rgba(255, 140, 0, 0.05) 0%, transparent 50%);\n  }\n  50% {\n    background: \n      radial-gradient(circle at 30% 30%, rgba(229, 122, 0, 0.08) 0%, transparent 50%),\n      radial-gradient(circle at 70% 70%, rgba(24, 27, 37, 0.08) 0%, transparent 50%),\n      radial-gradient(circle at 70% 30%, rgba(255, 140, 0, 0.03) 0%, transparent 50%);\n  }\n}\n\n.maintenance-content {\n  background: white;\n  border-radius: 20px;\n  padding: 50px 40px;\n  text-align: center;\n  max-width: 1200px;\n  width: 100%;\n  max-height: calc(100vh - 40px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(229, 122, 0, 0.1);\n  position: relative;\n  margin: 0;\n  box-sizing: border-box;\n  z-index: 1;\n  overflow-y: auto;\n}\n\n.maintenance-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #E57A00, #FF8C00);\n}\n\n.maintenance-icon {\n  margin-bottom: 30px;\n  animation: pulse 2s infinite;\n}\n\n.logo-image {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n  filter: drop-shadow(0 2px 4px rgba(229, 122, 0, 0.2));\n  transition: transform 0.3s ease;\n  border-radius: 12px;\n}\n\n.logo-image:hover {\n  transform: scale(1.05);\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}\n\n.maintenance-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.maintenance-message {\n  font-size: 1.1rem;\n  color: #4a5568;\n  line-height: 1.6;\n  margin-bottom: 35px;\n}\n\n.maintenance-details {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 35px;\n  flex-wrap: wrap;\n  gap: 20px;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 120px;\n  transition: transform 0.2s ease;\n}\n\n.detail-item:hover {\n  transform: translateY(-2px);\n}\n\n.detail-icon {\n  font-size: 2rem;\n  margin-bottom: 5px;\n  filter: drop-shadow(0 1px 2px rgba(229, 122, 0, 0.3));\n}\n\n.detail-item span:last-child {\n  font-size: 0.9rem;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.maintenance-timeline {\n  background: #fef7f0;\n  border-radius: 12px;\n  padding: 25px;\n  margin-bottom: 30px;\n  border-left: 4px solid #E57A00;\n}\n\n.timeline-text {\n  font-size: 1.1rem;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.timeline-subtext {\n  font-size: 0.9rem;\n  color: #718096;\n  margin: 0;\n}\n\n.maintenance-contact {\n  margin-bottom: 30px;\n}\n\n.maintenance-contact p {\n  color: #4a5568;\n  margin-bottom: 15px;\n  font-size: 1rem;\n}\n\n.contact-link {\n  display: inline-block;\n  background: linear-gradient(135deg, #E57A00, #FF8C00);\n  color: white;\n  padding: 12px 30px;\n  border-radius: 25px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(229, 122, 0, 0.3);\n}\n\n.contact-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(229, 122, 0, 0.4);\n  text-decoration: none;\n  color: white;\n}\n\n.maintenance-footer {\n  border-top: 1px solid #e2e8f0;\n  padding-top: 20px;\n}\n\n.maintenance-footer p {\n  color: #a0aec0;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Desktop - Pantallas grandes */\n@media (min-width: 1200px) {\n  .maintenance-content {\n    max-width: 1400px;\n    padding: 80px 60px;\n  }\n  \n  .logo-image {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .maintenance-title {\n    font-size: 3rem;\n    margin-bottom: 30px;\n  }\n  \n  .maintenance-message {\n    font-size: 1.3rem;\n    margin-bottom: 50px;\n    max-width: 900px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .maintenance-details {\n    margin-bottom: 50px;\n    gap: 40px;\n    max-width: 1000px;\n  }\n  \n  .detail-item span:last-child {\n    font-size: 1rem;\n  }\n  \n  .maintenance-timeline {\n    padding: 35px;\n    margin-bottom: 40px;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n    background: #fef7f0;\n    border-left: 4px solid #E57A00;\n  }\n  \n  .timeline-text {\n    font-size: 1.2rem;\n  }\n  \n  .timeline-subtext {\n    font-size: 1rem;\n  }\n  \n  .maintenance-contact {\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n/* Pantallas extra grandes (4K, ultrawide) */\n@media (min-width: 1600px) {\n  .maintenance-container {\n    padding: 30px;\n    height: 100vh;\n    min-height: 100vh;\n  }\n  \n  .maintenance-content {\n    max-width: 1400px;\n    max-height: calc(100vh - 60px);\n    padding: 80px 60px;\n    margin: 0;\n  }\n  \n  .maintenance-title {\n    font-size: 3.2rem;\n    margin-bottom: 35px;\n  }\n  \n  .maintenance-message {\n    font-size: 1.3rem;\n    margin-bottom: 50px;\n    max-width: 900px;\n  }\n  \n  .maintenance-details {\n    margin-bottom: 50px;\n    gap: 45px;\n    max-width: 1100px;\n  }\n  \n  .detail-item span:last-child {\n    font-size: 1rem;\n  }\n  \n  .maintenance-timeline {\n    padding: 35px;\n    margin-bottom: 45px;\n    max-width: 650px;\n    background: #fef7f0;\n    border-left: 4px solid #E57A00;\n  }\n  \n  .timeline-text {\n    font-size: 1.2rem;\n  }\n  \n  .timeline-subtext {\n    font-size: 1rem;\n  }\n  \n  .maintenance-contact {\n    max-width: 550px;\n  }\n  \n  .contact-link {\n    padding: 14px 35px;\n    font-size: 1rem;\n  }\n}\n\n/* Pantallas ultra anchas (más de 1920px) */\n@media (min-width: 1920px) {\n  .maintenance-container {\n    padding: 40px;\n    height: 100vh;\n    min-height: 100vh;\n    align-items: center;\n  }\n  \n  .maintenance-content {\n    max-width: 1400px;\n    max-height: calc(100vh - 80px);\n    padding: 80px 60px;\n    margin: 0;\n  }\n  \n  .logo-image {\n    width: 120px;\n    height: 120px;\n  }\n  \n  .maintenance-title {\n    font-size: 3.5rem;\n    margin-bottom: 40px;\n  }\n  \n  .maintenance-message {\n    font-size: 1.4rem;\n    margin-bottom: 60px;\n    max-width: 1000px;\n  }\n  \n  .maintenance-details {\n    margin-bottom: 60px;\n    gap: 50px;\n    max-width: 1200px;\n  }\n  \n  .detail-item span:last-child {\n    font-size: 1.1rem;\n  }\n  \n  .maintenance-timeline {\n    padding: 40px;\n    margin-bottom: 50px;\n    max-width: 700px;\n  }\n  \n  .timeline-text {\n    font-size: 1.3rem;\n  }\n  \n  .timeline-subtext {\n    font-size: 1.1rem;\n  }\n  \n  .maintenance-contact {\n    max-width: 600px;\n  }\n  \n  .contact-link {\n    padding: 15px 40px;\n    font-size: 1.1rem;\n  }\n}\n\n/* Pantallas ultrawide muy grandes (más de 2560px) */\n@media (min-width: 2560px) {\n  .maintenance-container {\n    padding: 50px;\n    height: 100vh;\n    min-height: 100vh;\n  }\n  \n  .maintenance-content {\n    max-width: 1600px;\n    max-height: calc(100vh - 100px);\n    padding: 90px 70px;\n    margin: 0;\n  }\n  \n  .logo-image {\n    width: 140px;\n    height: 140px;\n  }\n  \n  .maintenance-title {\n    font-size: 4rem;\n    margin-bottom: 50px;\n  }\n  \n  .maintenance-message {\n    font-size: 1.6rem;\n    margin-bottom: 70px;\n    max-width: 1200px;\n  }\n  \n  .maintenance-details {\n    margin-bottom: 70px;\n    gap: 60px;\n    max-width: 1400px;\n  }\n  \n  .detail-item span:last-child {\n    font-size: 1.2rem;\n  }\n  \n  .maintenance-timeline {\n    padding: 50px;\n    margin-bottom: 60px;\n    max-width: 800px;\n  }\n  \n  .timeline-text {\n    font-size: 1.5rem;\n  }\n  \n  .timeline-subtext {\n    font-size: 1.2rem;\n  }\n  \n  .maintenance-contact {\n    max-width: 700px;\n  }\n  \n  .contact-link {\n    padding: 18px 45px;\n    font-size: 1.2rem;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .maintenance-content {\n    max-width: 1000px;\n    padding: 70px 50px;\n  }\n  \n  .maintenance-title {\n    font-size: 2.8rem;\n  }\n  \n  .maintenance-message {\n    font-size: 1.2rem;\n  }\n}\n\n/* Tablet */\n@media (min-width: 769px) and (max-width: 991px) {\n  .maintenance-content {\n    max-width: 800px;\n    padding: 50px 30px;\n  }\n  \n  .maintenance-title {\n    font-size: 2.2rem;\n  }\n}\n\n/* Responsive Design - Móvil */\n@media (max-width: 768px) {\n  .maintenance-container {\n    padding: 20px 10px;\n    height: 100vh;\n    min-height: 100vh;\n    align-items: flex-start;\n    padding-top: 30px;\n  }\n  \n  .maintenance-content {\n    padding: 30px 20px;\n    margin: 0;\n    width: 100%;\n    max-height: calc(100vh - 60px);\n  }\n  \n  .logo-image {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .maintenance-title {\n    font-size: 2rem;\n    margin-bottom: 15px;\n  }\n  \n  .maintenance-message {\n    font-size: 1rem;\n    margin-bottom: 25px;\n  }\n  \n  .maintenance-details {\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 25px;\n    gap: 15px;\n  }\n  \n  .detail-item {\n    min-width: auto;\n  }\n  \n  .maintenance-timeline {\n    padding: 20px;\n    margin-bottom: 25px;\n  }\n  \n  .maintenance-contact {\n    margin-bottom: 20px;\n  }\n  \n  .maintenance-footer {\n    padding-top: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .maintenance-container {\n    padding: 15px 5px;\n    height: 100vh;\n    min-height: 100vh;\n    padding-top: 20px;\n  }\n  \n  .maintenance-content {\n    padding: 20px 15px;\n    border-radius: 15px;\n    max-height: calc(100vh - 40px);\n  }\n  \n  .logo-image {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .maintenance-title {\n    font-size: 1.8rem;\n    margin-bottom: 12px;\n  }\n  \n  .maintenance-message {\n    font-size: 0.95rem;\n    margin-bottom: 20px;\n    line-height: 1.5;\n  }\n  \n  .maintenance-details {\n    margin-bottom: 20px;\n    gap: 12px;\n  }\n  \n  .detail-icon {\n    font-size: 1.5rem;\n  }\n  \n  .detail-item span:last-child {\n    font-size: 0.85rem;\n  }\n  \n  .maintenance-timeline {\n    padding: 15px;\n    margin-bottom: 20px;\n  }\n  \n  .timeline-text {\n    font-size: 1rem;\n  }\n  \n  .timeline-subtext {\n    font-size: 0.85rem;\n  }\n  \n  .maintenance-contact {\n    margin-bottom: 15px;\n  }\n  \n  .maintenance-contact p {\n    font-size: 0.9rem;\n    margin-bottom: 10px;\n  }\n  \n  .contact-link {\n    padding: 10px 25px;\n    font-size: 0.9rem;\n  }\n  \n  .maintenance-footer {\n    padding-top: 12px;\n  }\n  \n  .maintenance-footer p {\n    font-size: 0.8rem;\n  }\n}\n\n/* Pantallas muy pequeñas (menos de 360px) */\n@media (max-width: 360px) {\n  .maintenance-container {\n    padding: 10px 2px;\n    height: 100vh;\n    min-height: 100vh;\n    padding-top: 15px;\n  }\n  \n  .maintenance-content {\n    padding: 15px 10px;\n    border-radius: 12px;\n    max-height: calc(100vh - 30px);\n  }\n  \n  .logo-image {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .maintenance-title {\n    font-size: 1.6rem;\n    margin-bottom: 10px;\n  }\n  \n  .maintenance-message {\n    font-size: 0.9rem;\n    margin-bottom: 18px;\n    line-height: 1.4;\n  }\n  \n  .maintenance-details {\n    margin-bottom: 18px;\n    gap: 10px;\n  }\n  \n  .detail-icon {\n    font-size: 1.3rem;\n  }\n  \n  .detail-item span:last-child {\n    font-size: 0.8rem;\n  }\n  \n  .maintenance-timeline {\n    padding: 12px;\n    margin-bottom: 18px;\n  }\n  \n  .timeline-text {\n    font-size: 0.95rem;\n  }\n  \n  .timeline-subtext {\n    font-size: 0.8rem;\n  }\n  \n  .maintenance-contact {\n    margin-bottom: 12px;\n  }\n  \n  .maintenance-contact p {\n    font-size: 0.85rem;\n    margin-bottom: 8px;\n  }\n  \n  .contact-link {\n    padding: 8px 20px;\n    font-size: 0.85rem;\n  }\n  \n  .maintenance-footer {\n    padding-top: 10px;\n  }\n  \n  .maintenance-footer p {\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
